module.exports = __webpack_public_path__ + "img/eskoot.64e1861a.png";